var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2_00000066507275525711108510000001418198351282156679_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 200.7",
    style: {
      enableBackground: "new 0 0 256 200.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.7,72.5H0V0h21.7V72.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.9,61.9c0,20.9-14.9,34.9-36.6,34.9s-36.6-14-36.6-34.9s15.1-34.5,36.6-34.5S107.9,41.2,107.9,61.9z  M87.3,61.9c0-9.6-6.7-16-16-16s-16,6.4-16,16s6.7,16.4,16,16.4S87.3,71.8,87.3,61.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.7,61.9c0,20.9-14.9,34.9-36.6,34.9s-36.6-14-36.6-34.9s15.1-34.5,36.6-34.5S191.7,41.2,191.7,61.9z  M171,61.9c0-9.6-6.7-16-16-16s-16,6.4-16,16s6.7,16.4,16,16.4S171,71.8,171,61.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.8,93.9c-7.5,2-12.1,2.7-20.2,2.7c-16.1,0-25-9.7-25-27.4V49.3h-12.4V30h12.4V8h21.6v22H251v19.3h-19.8 V67c0,6.4,2.5,10.3,9.2,10.3c3.2,0,6.7-0.3,12.5-1.1L254.8,93.9L254.8,93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.6,105.5c5.1-0.7,11.1-1.2,16-1.2c21.4,0,32.9,13.6,33.3,33.8c0,23.3-15.4,34.4-31.4,34.4 c-10.4,0-17.4-0.1-39.4-2.7V84.2h21.6L21.6,105.5L21.6,105.5z M21.6,122.8v31.3c6.7,0.7,10.9,0.9,13.1,0.9 c10.1,0,15.4-6.7,15.4-16.9c0-9.6-4.7-16.4-16.1-16.4C30.9,121.7,26.2,122.1,21.6,122.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.6,138.2c0,20.9-14.9,34.9-36.6,34.9s-36.6-14-36.6-34.9s15.1-34.5,36.6-34.5S151.6,117.5,151.6,138.2z  M131,138.2c0-9.6-6.7-16-16-16s-16,6.4-16,16s6.7,16.4,16,16.4S131,148.1,131,138.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.1,200.7h-23.8l15.3-33.4l-30.8-61H179l18,36l16.4-36h24.2L194.1,200.7L194.1,200.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.d2593193.svg";
export { ForwardRef as ReactComponent };